import { useTranslation } from 'react-i18next'
import { cn } from '../lib/utils'
import { Spinner } from './ui/spinner'

interface LoadingProps {
  withText?: boolean
  className?: string
}

export function Loading({ withText = true, className }: LoadingProps) {
  const { t } = useTranslation()
  return (
    <div
      role="status"
      className={cn('flex h-full items-center justify-center', className)}
    >
      <div className="flex flex-col items-center gap-4">
        {withText && (
          <p className="text-sm text-muted-foreground">
            {t('loading', { defaultValue: 'Loading' })} ...
          </p>
        )}
        <Spinner size="lg" />
      </div>
    </div>
  )
}
